import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import c from 'classnames';
import { colors } from '../../styles/';
import { DropdownListItemProps } from './props';
import Icon from '../icons/icon';

class DropdownListItem extends React.Component<DropdownListItemProps, any> {
  public render() {
    const { className, text, onClick, icon, size } = this.props;

    return (
      <div className={c(className, 'list-item')} onClick={onClick}>
        {(icon || size) && (
          <Icon
            baseColor={colors.grey700}
            className="icon-wrapper"
            icon={icon || 'empty'}
            size={size}
          />
        )}
        {text}
      </div>
    );
  }
}

const StyledDropdownListItem = styled(DropdownListItem)`
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 0.77rem;

  :not(:last-child) {
    box-shadow: 0 1px 0 0 ${colors.grey500};
  }
  :hover {
    background-color: ${colors.grey50};
    path,
    polygon {
      fill: ${colors.black};
    }
  }
  :first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  :last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .icon-wrapper {
    margin-right: 1em;
  }
`;

export default StyledDropdownListItem;
